import React from 'react';
import { formatDate } from '../Format';
import { CellTwoLines } from './CellTwoLines';

const SdkCell = ({sdk, i18n}) => {
  return <CellTwoLines text={sdk.version} subtext={formatDate(sdk.date)}/>
}

export default SdkCell;